// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ft","header":"fu","message":"fv","copyMessage":"fw","button":"fx"};